module.exports = __webpack_public_path__ + "withdraw_stm_button_1.svg?89cd299b5696d455d3a1571fb2b2ac38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw_stm_button_1.svg
// module id = 961
// module chunks = 2